module.exports = __webpack_public_path__ + "static/img/manual-3.9a9b611.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-3.png
// module id = 27uZ
// module chunks = 4